















import Vue from 'vue';

export default Vue.extend({
  name: 'Checkbox',
  props: {
    name: String,
    required: Boolean,
  },
  methods: {
    setMessage(e: Event): void {
      const field = e.currentTarget as HTMLInputElement;

      if (field) {
        field.setCustomValidity('');

        if (!field.validity.valid) {
          field.setCustomValidity('Campo obrigatório');
        }
      }
    },
  },
});
